export default "__VITE_ASSET__5515e6bb__"